import { NgModule } from '@angular/core';
import { PaymentInstructionCodePipe } from './payment-instruction-code.pipe';

@NgModule({
  declarations: [PaymentInstructionCodePipe],
  exports: [PaymentInstructionCodePipe]
})
export class PaymentInstructionCodeModule {}
